import Storage from "./constants/storage.es6";
import NewsList from "./features/news/newsList.es6";
import NewsDetail from "./features/news/newsDetail.es6";
import MarqueeTitle from "./features/animation/marqueeTitle.es6";

export default class News {
    constructor() {
        this.STORAGE = new Storage();
        this.marqueeTitle = null;

        if (document.body.classList.contains("news-list")) {
            this.newsList = new NewsList();
        } else {
            this.newsDetail = new NewsDetail();
        }

        this.init();
    }

    init() {
        this.skipNewsIntro();

        if (document.querySelector(".js-gsap-marquee")) {
            this.marqueeTitle = new MarqueeTitle();
            //requestAnimationFrame(() => this.marqueeTitle.refresh());
            // TODO:MarqueeTitle内に記述がないが不要か？
        }
    }

    //NEWSのイントロ演出を同タブ2回目以降はスキップ
    skipNewsIntro() {
        if (this.STORAGE.data.newsIntro) {
            this.STORAGE.set("newsIntro", false);
        } else {
            document.body.classList.add("-skipnewsintro");
        }
    }
}

new News();
